import React, { useCallback } from 'react';
import { router, usePage } from '@inertiajs/react';
import { useTrans } from '../../../hooks/useTrans';
import LanguageSwitcher from '../../LanguageSwitcher';

export default function AuthLayout({ children }) {
    const translate = useTrans();
    const { auth, routes } = usePage().props;

    const handleLanguageSwitch = useCallback((languageKey) => {
        router.post('/language', { _method: 'PUT', language_id: languageKey });
    }, []);

    return (
        <div className="min-h-screen bg-[#003545] overflow-hidden">
            <div className="flex min-h-screen items-center justify-center relative">
                {/* Language switcher + logout */}
                <div className="absolute top-4 right-4 z-20 flex items-center gap-2">
                    <LanguageSwitcher onSwitch={handleLanguageSwitch} />
                    {auth && (
                        <form method="POST" action={routes?.logout}>
                            <input type="hidden" name="_token" value={document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? ''} />
                            <button type="submit" className="rounded-[6px] border-2 border-[#0e8e6a] bg-[#0e8e6a] px-4 py-1 text-[12px] font-black text-white hover:bg-transparent hover:text-[#0e8e6a] transition-colors cursor-pointer">
                                {translate('Uitloggen')}
                            </button>
                        </form>
                    )}
                </div>

                {/* Main content */}
                <div className="relative z-10 w-full flex flex-col items-center">
                    {children}
                </div>

                {/* Pay-off logo */}
                <div className="absolute bottom-[50px] left-[30px] z-10 hidden md:block">
                    <div className="w-[352px] h-[68px] bg-contain bg-no-repeat" style={{ backgroundImage: 'url(/assets/img/layout/pay-off.svg)' }} />
                </div>

                {/* Human illustration */}
                <div className="absolute bottom-0 right-[200px] z-0 hidden lg:block">
                    <div className="w-[370px] h-[510px] bg-contain bg-no-repeat" style={{ backgroundImage: 'url(/assets/img/layout/girl-holding-tablet.png)' }} />
                </div>
            </div>
        </div>
    );
}
